import { Expose } from "class-transformer";
import { CreateQuestionDto } from "@/core/features/questions/create-question.dto";

export class CreateSubquestionDto extends CreateQuestionDto {
  @Expose()
  relatedAnswerId: string;
}
